import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { Workstation } from '@weave/schema-gen-ts/dist/schemas/schedule/settings/v2/settings.pb';
import type { AppointmentType } from '@frontend/api-appointment-types';
import { DataSourcesTypes } from '@frontend/api-data-sources';
import { useAppScopeStore } from '@frontend/scope';
import { TagType } from '@frontend/design-system';
import { ExtendedProvider } from '../../../../../../types';
import { getRequestTags } from '../utils';
import {
  ReducedAppointmentType,
  ReducedOperatory,
  ReducedPractitioner,
  ReviewRequestReturnType,
  useReviewRequest,
} from './useReviewRequest';
import { useSyncAppBySource } from './useSyncAppBySource';

type UseManageScheduleRequestModalDetailsReturnType = {
  tags: TagType[];
  access: DataSourcesTypes.AccessDataResponse;
  isSyncAppDetailsLoading: boolean;
  appointmentTypes: AppointmentType[] | ReducedAppointmentType[];
  providers: ExtendedProvider[] | ReducedPractitioner[];
  workstations: Workstation[] | ReducedOperatory[];
  isLoading: boolean;
  selectedAppointmentDetails: ReviewRequestReturnType['selected'];
};

export const useManageScheduleRequestModalDetails = (
  selectedScheduleRequest: ScheduleRequest | undefined
): UseManageScheduleRequestModalDetailsReturnType => {
  const locationId = selectedScheduleRequest?.locationId ?? '';

  const { getScopeName } = useAppScopeStore();

  const { lists, isLoading, selected: selectedAppointmentDetails } = useReviewRequest(selectedScheduleRequest);
  const { access, isLoading: isSyncAppDetailsLoading } = useSyncAppBySource(locationId);

  const { list: tags } = getRequestTags(
    selectedScheduleRequest?.dateTime ?? '',
    selectedScheduleRequest?.schedulee,
    getScopeName(locationId)
  );

  return {
    tags,
    access,
    isSyncAppDetailsLoading,
    isLoading,
    selectedAppointmentDetails,
    appointmentTypes: lists.appointmentTypes,
    providers: lists.providers,
    workstations: lists.workstations,
  };
};
